/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import {getHost, reduceParams, parseParams, querystring} from '@ywfe/utils';



  const {basePath = '', loginPath = ''} = getHost("PROAUTH", "446")



  
    
      export interface API47335Item {
        
      /** 任务id */
      id?: number;
        
      /** 任务标题 */
      taskTitle?: string;
        
      /** 任务状态(0:未启用;1:待处理;2:处理中;3:已取消;4:已暂停;5:已完成) */
      taskStatus?: number;
        
      /** 任务状态描述 */
      taskStatusDesc?: string;
        
      /** 任务创建类型(0:人工创建,1:系统创建) */
      createType?: number;
        
      /** 任务创建类型描述 */
      createTypeDesc?: string;
        
      /** 业务域(0:自定义,1:直播,2:商家,3:内控,4:大数据,5:粉丝，默认自定义) */
      bizDomain?: number;
        
      /** 业务域图标 */
      bizDomainIco?: string;
        
      /** 任务执行者姓名列表 ,String */
      executorNameList?: string[];
        
      /** 计划开始时间 */
      startTime?: any;
        
      /** 计划完成时间 */
      endTime?: any;
        
      /** 实际完成时间 */
      actualEndTime?: any;
        
      /** 优先级标签 */
      priorityTag?: string;
        
      /** 优先级标签描述 */
      priorityTagDesc?: string;
        
      /** 逾期标签描述 */
      overdueTagDesc?: boolean;
        
      /** 任务评级(1~5) */
      evaluateLevel?: number;
        
      };
    
  



  export interface API47335Req {
  
  /** 任务查询类型(0:我执行的任务,1:我发起的任务,2:抄送我的任务) */
  queryType: any;
  /** 任务标题 */
  taskTitle: any;
  /** 优先级标签 */
  priorityTag: any;
  /** 任务状态(0:未启用;1:待处理;2:处理中;3:已关闭;4:已暂停;5:已完成) */
  taskStatus: any;
  /** 任务执行人id */
  executorId: any;
  /** 抄送人id */
  taskCCId: any;
  /** 任务发起人Id */
  creator: any;
  /** 开始时间 */
  startTime: any;
  /** 完成时间 */
  endTime: any;
  /** 排序字段 */
  orderFiled: any;
  /** 排序类型(0:降序,1:升序) */
  orderType: any;
  /**  */
  pageSize: any;
  /**  */
  pageIndex: any;
  /**  */
  rowId: any;
  /**  */
  jumpType: any;
  /**  */
  searchCount: any;
  /**  */
  orderObjects: any;
  };



  export interface API47335Res {
    /** T  */
    list?: API47335Item[];
    /**   */
    totalNumber?: any;
    /**   */
    totalPage?: any;
    /**   */
    rowId?: string;
    /**   */
    hasNext?: boolean;
    /**   */
    pageSize?: any;
    /**   */
    pageIndex?: any;
    
  };


// 47335 分页查询任务

export const usePostAPI47335 = () => {
  let isMount = true;
  const [isAPI47335Loading, setIsAPI47335Loading] = useState(false);
  const [dataAPI47335, setDataAPI47335] = useState<API47335Res>({} as API47335Res);
  const fetchAPI47335Data = async (inputs: API47335Req, config?: YWRequestConfig): Promise<API47335Res> => {
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47335Req>) || {}) as API47335Req;
    
    if ( isMount ) {
      setIsAPI47335Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API47335Res>(`${basePath}/workTask/pageQueryWorkTask`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI47335(res || {} as API47335Res);
        setIsAPI47335Loading(false);
      }
      return res;
    } catch (error) {
      console.error('API error: ', error);
      if ( isMount ) {
        setIsAPI47335Loading(false);
      }
      return false as unknown as API47335Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47335Loading,
    dataAPI47335,
    fetchAPI47335Data,
  }
}

